<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" size="small" :inline="true">
      <el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="success" icon="el-icon-edit" :disabled="single" @click="handleUpdate">修改</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">删除</el-button>
      </el-form-item>
      <el-form-item label="充值金额" prop="money">
        <el-input
          v-model="queryParams.money"
          placeholder="充值金额"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="pageList" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" type="index" width="100" />
      <el-table-column label="会员时长(月)" prop="timer" :show-overflow-tooltip="true" width="200" />
      <el-table-column label="实际价格" prop="money" :show-overflow-tooltip="true" width="250" />
      <el-table-column label="状态" prop="status" :formatter="statusFormat" :show-overflow-tooltip="true" width="100" />
      <el-table-column label="创建时间" prop="createTime" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          >修改
          </el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除
          </el-button>
          <el-button
            v-if="scope.row.status==1"
            type="text"
            icon="el-icon-delete"
            @click="handleStatusChange(scope.row)"
          >禁用
          </el-button>
          <el-button
            v-if="scope.row.status!=1"
            type="text"
            icon="el-icon-delete"
            @click="handleStatusChange(scope.row)"
          >启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="pagination.total>0"
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.limit"
      @pagination="handleQuery"
    />

    <!-- 添加或修改充值配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="form.status"
            placeholder="状态"
            clearable
          >
            <el-option label="正常" :value="1"/>
            <el-option label="禁用" :value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item label="会员时长" prop="timer">
          <el-input v-model="form.timer" type="number" placeholder="请输入会员时长" />
        </el-form-item>
        <el-form-item label="实际价格" prop="money">
          <el-input v-model="form.money" type="number" placeholder="实际价格" />
        </el-form-item>
        <el-form-item v-show="false" label="类型" prop="content">
          <el-input v-model="form.type" placeholder="类型" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialog.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, detail, update, add, del, patch } from '@/api/member/price'
import Tinymce from '@/components/Tinymce'

export default {
  components: {
    Tinymce
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams: {
        appType: undefined,
        type: 1,
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false
      },
      // 菜单列表
      menuOptions: [],
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        num: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    appTypeFormat(row) {
      return row.appType === 1 ? '苹果' : '安卓'
    },
    statusFormat(row) {
      return row.status === 1 ? '使用中' : '未使用'
    },
    handleQuery() {
      this.queryParams.type = 1
      this.queryParams.page = this.pagination.page
      this.queryParams.limit = this.pagination.limit
      list(this.queryParams).then(response => {
        this.pageList = response.data
        this.pagination.total = response.total
        this.loading = false
      })
    },
    handleResetQuery() {
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.queryParams = {
        name: undefined
      }
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    handleStatusChange(row) {
      const text = row.status === 2 ? '启用' : '停用'
      this.$confirm('确认要"' + text + '"数据项吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        const status = row.status === 1 ? 2 : 1
        return patch(row.id, { status: status })
      }).then(() => {
        this.$message.success(text + '成功')
        this.handleQuery()
      }).catch(function() {
        row.status = row.status === 1 ? 0 : 1
      })
    },
    handleAdd() {
      this.resetForm()
      this.dialog = {
        title: '新增充值',
        visible: true
      }
    },
    handleUpdate(row) {
      this.resetForm()
      this.dialog = {
        title: '修改充值',
        visible: true
      }
      const id = row.id || this.ids
      detail(id).then(response => {
        this.form = response.data
      })
    },
    handleDelete(row) {
      const ids = [row.id || this.ids].join(',')
      console.log(this.ids)
      this.$confirm('是否确认删除选中的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        del(ids).then(() => {
          this.$message.success('删除成功')
          this.handleQuery()
        })
      }).catch(() =>
        this.$message.info('已取消删除')
      )
    },
    handleSubmit: function() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const id = this.form.id
          if (id !== undefined) {
            update(this.form.id, this.form).then(() => {
              this.$message.success('修改成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          } else {
            this.form.type = 1
            add(this.form).then(() => {
              this.$message.success('新增成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        id: undefined,
        name: undefined,
        url: undefined
      }
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
    }
  }
}
</script>
